type BannerImgtextProps = {
  title: string;
  img: string;
};

const BannerImgText = ({ title, img }: BannerImgtextProps) => {
  return (
    <div className="bg-center bg-cover bg-no-repeat bg-[url('/media/images/2600x1200/bg-1.png')]">
      <div className="container-fixed">
        <div className="flex flex-col items-center gap-2 lg:gap-3.5 py-4 lg:pt-5 lg:pb-10">
          <img
            className="rounded-full border-3 border-success size-[100px] shrink-0"
            src={img}
          />
          <div className="flex items-center gap-1.5">
            <div className="text-lg leading-5 font-semibold text-gray-900">
              {title}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerImgText;
